import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_LANGUAGE, TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../shared/service/environmentconfig.service';
import { WebApiService } from '../../../shared/service/webapi.service';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { request } from 'http';

import { Data } from '@angular/router';
import { differenceInCalendarDays } from 'date-fns';
import { now } from 'moment';

interface ItemData {
  sid: string;
  endDate: Date;
  employeeID: string;
  employeeName: string;
  proxyID: string;
  proxyName: string;
  startDate: Date;
  pono: string;
  id: string;

}

@Component({
  selector: 'app-AddProxy-Change',
  templateUrl: './AddProxy-Change.component.html'
})


export class AddProxyChangeComponent extends BaseComponent implements OnInit {
  @Input() isEdit: boolean = false;
  @Input() editData: any;
  @Input() isAdd: boolean = false;

  editCache: { [key: string]: { edit: boolean; data: ItemData } } = {};
  loading: boolean = false;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  fileList: NzUploadFile[] = [];
  validateForm: FormGroup;
  pageSize: number = 20;
  dateNow: any = this.getTheDateStringforMMDD();
  pageIndex: number = 1;
  listOfData: ItemData[] = [];
  nzTotal: number = 0;
  type: string;
  tw: boolean;
  cn: boolean;
  en: boolean;
  userOptionList = [];
  edit: boolean;
  editboolean: boolean = false;
  isShowCondition: boolean = true;
  today = new Date();
  dateFormat = 'yyyy/MM/dd';


  tabIndex: number = 0;
  @Input() set index(value) {
    if (!!value || value === 0) {
      this.tabIndex = value;
    }
  };

  constructor(private authService: AuthService,
    private webApiService: WebApiService,
    private translate: TranslateService,
    private NzMessageService: NzMessageService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private fb: FormBuilder,
    private http: HttpClient) { super(); }



  startEdit(sid: string): void {
    this.editCache[sid].edit = true;
  }

  cancelEdit(sid: string): void {
    const index = this.listOfData.findIndex(item => item.sid === sid);
    this.editCache[sid] = {
      data: { ...this.listOfData[index] },
      edit: false
    };
  }

  saveEdit(sid: string): void {
    const index = this.listOfData.findIndex(item => item.sid === sid);
    Object.assign(this.listOfData[index], this.editCache[sid].data);

    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.ChangeAgentEndTime.url}?PoNo=` + this.editCache[sid].data.pono + '&ProxyID=' + this.editCache[sid].data.proxyID + '&date=' + this.getTheDateString_(this.editCache[sid].data.endDate) + '&Id=' + this.editCache[sid].data.id;
    const params = {
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.NzMessageService.success('變更代理人結束時間成功');
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
    this.editCache[sid].edit = false;
    this.getResultData();
  }

  updateEditCache(): void {
    this.listOfData.forEach(item => {
      this.editCache[item.sid] = {
        edit: false,
        data: { ...item }
      };
    });
  }

  ngOnInit() {
    this.validateForm = this.fb.group({
      proxyId: [''],
      EndDate: ['', [Validators.required]],

    });
    this.getResultData();
  }

  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();

  }

  nzPageIndexChange(event: number): void {
    this.pageIndex = event;

    this.getResultData();
    this.loading = false;

  }

  getResultData() {
    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.ChangeAgentQuery.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        ProxyId: this.validateForm.controls['proxyId'].value || ''
      },
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res != null) {
          this.listOfData = res.map(
            (item) => {
              item.startDate = this.getTheDateString_(item.startDate);
              item.endDate = this.getTheDateString_(item.endDate);
              return item;
            });
        }
        this.updateEditCache()
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
  }

  onEdit(data) {
    this.editData = { ...data };
    this.isEdit = true;
  }

  closeAdd() {
    this.isAdd = false;
    this.isEdit = false;
    this.ngOnInit()

  }

  GetLanguage() {
    if (sessionStorage.getItem("wmsmlang") == "zh-CN") {
      this.cn = true;
      this.tw = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "zh-TW") {
      this.tw = true;
      this.cn = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "en") {
      this.en = true;
      this.cn = false;
      this.tw = false;
    }

  }



  userSearch(event) {
    this.loading = true
    event = event.trim().toUpperCase();
    if (event.length > 5) {
      const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.QueryUser.url}` + event;
      setTimeout(() => {
        this.webApiService.doGet(url).toPromise().then(
          (res) => {
            this.loading = true;
            this.userOptionList = res.data.slice(0, 10);
            this.loading = false
          },
          (error) => {
            this.NzMessageService.error(error.msg);
            this.loading = false
          }
        );
      }, 800);

    }
    this.loading = false
  }

  getQuery(value) {
    this.isShowCondition = value;
  }
  onSearch() {
    this.isShowCondition = !this.isShowCondition;
    this.getResultData()
  }

  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) >= 0;


}
